export default "__VITE_ASSET__CzMStWvr__"